// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"e30534c09b41a710bfdd","691":"97ef27fdc6524b0a94d2","731":"b4b652b94431c14365af","843":"68aca87bdbffc9e07093"}[chunkId] + ".js";
};